import jsonCountryMap from '@/constants/countries.json';

export const countries: { [index: string]: string } = jsonCountryMap;

export const getCountries = () => {
  let countryOptions = Object.entries(countries).map(([id, title]) => ({
    id,
    children: title,
    value: id,
  }));

  countryOptions = countryOptions.sort((a, _) => {
    if (a.children === 'Canada') {
      return -1;
    } else if (a.children === 'United States of America') {
      return -1;
    } else {
      return 1;
    }
  });

  return countryOptions;
};
